import { getStripeChargeEventsData } from '../libs/apis/ChargeEventApi';

export const GET_STRIPE_CHARGE_EVENT_REQUEST =
  'GET_STRIPE_CHARGE_EVENT_REQUEST';
export const GET_STRIPE_CHARGE_EVENT_SUCCESS =
  'GET_STRIPE_CHARGE_EVENT_SUCCESS';
export const GET_STRIPE_CHARGE_EVENT_FAILURE =
  'GET_STRIPE_CHARGE_EVENT_FAILURE';

export const getStripeChargeEvents = params => dispatch => {
  dispatch({ type: GET_STRIPE_CHARGE_EVENT_REQUEST });
  return getStripeChargeEventsData(params)
    .then(response =>
      dispatch({
        type: GET_STRIPE_CHARGE_EVENT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_STRIPE_CHARGE_EVENT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
